import PropTypes from "prop-types";
import React, {
	Component
} from "react";
import {
	TouchableOpacity,
	View,
	StyleSheet,
} from "react-native";

import InputContainer from "./Layout/InputContainer";
import ErrorMessage from "./Layout/ErrorMessage";
import StyledText from "ae-base/Base/StyledText";
import InputLabel from "./Layout/InputLabel";

import Style from "@aetonix/styles";

var styles = StyleSheet.create({
	bigger: {
		height: 32,
		width: 32
	},
	biggerSelected: {
		height: 24,
		width: 24
	},
	biggest: {
		height: 48,
		width: 48
	},
	biggestSelected: {
		height: 40,
		width: 40
	},
	container: {
		alignItems: "center",
		flexDirection: "row",
		justifyContent: "flex-end",
		marginVertical: Style.layout.marginSlim
	},
	marginBigger: {
		marginVertical: Style.layout.marginLarge
	},
	marginBiggest: {
		marginVertical: Style.layout.marginHuge
	},
	radio: {
		alignItems: "center",
		borderColor: Style.colors.tertiary,
		borderRadius: 55,
		borderWidth: 2,
		height: 24,
		justifyContent: "center",
		marginHorizontal: Style.layout.marginSlim,
		width: 24
	},
	selected: {
		backgroundColor: Style.colors.tertiary,
		borderRadius: 55,
		height: 16,
		width: 16
	},
	textContainer: {
		flexShrink: 1
	},
	touchable: {
		alignSelf: "flex-start"
	}
});

export default class RadioButtons extends Component {
	constructor(props){
		super(props);

		this.state = {
			selected: this.props.defaultValue || false,
		};

		this.handleChange = handleChange.bind(this);
	}

	render(){
		var context = this.context;
		var localize = context.localize;
		var textsize = context.textsize;
		var localizeFrom = context.localizeFrom;
		var props = this.props;
		var contrast = props.contrast;
		var errors = props.errors;
		var schema = props.schema;
		var id = props.id;
		var defaultValue = props.defaultValue;

		var options = Array.isArray(schema.enum) ? schema.enum : [];
		var value_localization = schema.value_localization || {};

		var containerStyles = [styles.container];

		var radioStyle = [styles.radio];
		var selectedStyle = [styles.selected];

		if(textsize === 1){
			radioStyle.push(styles.bigger);
			selectedStyle.push(styles.biggerSelected);
			containerStyles.push(styles.marginBigger);
		} else if (textsize === 2){
			radioStyle.push(styles.biggest);
			selectedStyle.push(styles.biggestSelected);
			containerStyles.push(styles.marginBiggest);
		}

		var renderRadios = options.map(function (element, index) {
			var onPress = function () {
				this.handleChange(index);
			}.bind(this);
			var localizedTitle = localizeFrom(value_localization, element) || localize(value_localization + "." + element) || element;
			var renderSelected = null;
			if (this.state.selected === element || defaultValue === element) {
				renderSelected = <View style={selectedStyle} />;
			}

			return (
				<TouchableOpacity id={context.id_prefix + id + "_" + index} style={styles.touchable} accessible={true} accessibilityComponentType="button" onPress={onPress}>
					<View   style={containerStyles} >
						<View style={radioStyle}>
							{renderSelected}
						</View>
						<View accessibilityRole="checkbox" accessibilityLabel={localizedTitle || "Radio Button"} style={styles.textContainer}>
							<StyledText contrast={contrast}>{localizedTitle}</StyledText>
						</View>
					</View>
				</TouchableOpacity>);
		}.bind(this));

		return (
			<InputContainer>
				<ErrorMessage id={context.id_prefix + props.id + "_error"} errors={errors} schema={schema} />
				<InputLabel schema={schema} />
				{renderRadios}
			</InputContainer>
		);
	}
}

function handleChange(index) {
	var defaultValue = this.props.defaultValue;
	var schema = this.props.schema;
	var options = schema.enum;

	var updatedValue = options[index] || defaultValue;

	var onChange = this.props.onChange;
	if(onChange) onChange(updatedValue);

	this.setState({
		selected: updatedValue
	});
}

RadioButtons.contextTypes = {
	textsize: PropTypes.number,
	id_prefix: PropTypes.string,
	localize: PropTypes.func,
	localizeFrom: PropTypes.func
};
